export default {
  mutateQuestionnaireFormLoadingState(state, loading) {
    state.questionnaireFormLoading = loading;
  },
  setQuestionnaireFormDataState(state, data) {
    const questionnaireFormDataCgp = {
      city_id: data.basic_information.location,
      title: data.basic_information.title,
      summary: data.basic_information.summary
    };

    const questionnaireFormDataTop20tech = {
      city_id: data.basic_information.location,
      industry: data.basic_information.industry,
      job_title: data.basic_information.job_title
    };

    state.questionnaireFormDataCgp = questionnaireFormDataCgp;
    state.questionnaireFormDataTop20tech = questionnaireFormDataTop20tech;
  },
  mutateQuestionnaireFormErrorsState(state, error) {
    state.questionnaireFormErrors = error;
  },
  mutateQuestionnaireFormDataState(state, data) {
    state.questionnaireFormDataCgp = {...state.questionnaireFormDataCgp, ...data};
    state.questionnaireFormDataTop20tech = {...state.questionnaireFormDataTop20tech, ...data};
  }
};
